export const CANCELLATION_TEMPORARILY_DISABLED = true

// trip status types
export const UPCOMING_STATUS = 'upcoming'
export const RESERVED_STATUS = 'reserved'
export const ON_HOLD_STATUS = 'on hold'
export const CANCELLED_STATUS = 'cancelled'

// Trip types
export const AIR_TRIP = 'air'
export const TRAIN_TRIP = 'train'
export const LOCAL_TRIP = 'activity'
export const HOTEL_TRIP = 'hotel'
export const FPH_TRIP = 'fph'
export const VERTICAL_TRIPS = [AIR_TRIP, TRAIN_TRIP, LOCAL_TRIP, HOTEL_TRIP, FPH_TRIP]

// Icon color, size and label
export const SUPPORT_ICON = 'support'
export const EXPRESSWAY_ICON = 'setting'
export const ACCOUNT_ICON_FILL_COLOR = '#ccc'
export const ACCOUNT_ICON_SIZE = '26px'

// Verticals
export const VERTICALS = {
  AIR: 'AIR',
  HOTEL: 'HOTEL'
}

// API Status
export const API_STATUS = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  DEFAULT: 'DEFAULT'
}

// Payment mode
export const PAYMENT_MODE = {
  SUPERCOINS: 'SUPERCOINS'
}
